import "./Footer.scss";

export default function Footer() {
  return (
    <footer>
      copyright © 2023 - created by
      <a
        href="https://www.linkedin.com/in/timjeanmart/"
        target="_blank"
        rel="noreferrer"
      >
        tim jeanmart
      </a>
    </footer>
  );
}
